import React from 'react';
import { Accordion } from 'semantic-ui-react';
import AccordionHeader from './AccordionHeader';

const SimpleAccordion = ({
  active,
  children,
  headerId,
  headerText,
  index,
  onClick,
}) => (
  <>
    <AccordionHeader
      active={active}
      index={index}
      onClick={onClick}
      headerId={headerId}
      headerText={headerText}
      className="aridhia-simple-accordion"
    />
    {active && (
      <Accordion.Content active={active}>
        {children}
      </Accordion.Content>
    )}
  </>
);

export default SimpleAccordion;
